import type { ColumnDef } from '@/components/ui';
import { renderRawScalarCell } from './table-cell-renderers';

export interface IRawColumnSpec<T> {
  key: keyof T;
  header: string;
}

const DEFAULT_FILTER = { type: 'text' as const, placeholder: 'Filter...' };

export function buildRawColumns<T>(specs: ReadonlyArray<IRawColumnSpec<T>>): ColumnDef<T>[] {
  return specs.map((spec) => ({
    id: String(spec.key),
    header: spec.header,
    accessor: spec.key,
    sortable: true,
    filter: DEFAULT_FILTER,
    cell: renderRawScalarCell,
  }));
}
